import React from 'react';
import { EditorialNote } from './EditorialNote';
import { IDecisionModalProps } from './decisionModalHelper';
import { useHasSpecificChild } from 'src/hooks/useHasSpecificChild';
import { useDevToast } from '../../../hooks/useDevToast';

export type IEditorialDecisionModal = ((
  props: any
  // We need this to differentiate this component from a generic React one
  // Otherwise we can't enforce it and regular components will bypass this.
) => React.ReactNode) & { __isEditorialModal: true };

const EditorialDecisionModalWrapper: React.FC<
  EditorialDecisionModalWrapperProps
> = ({ children }) => {
  const devToast = useDevToast();
  const hasEditorialNote = useHasSpecificChild(children, EditorialNote);
  if (!hasEditorialNote) {
    devToast({
      title: 'EditorialNote is required in this modal',
      description:
        'EditorialDecisionModalWrapper must render <EditorialNote /> somewhere in its children.'
    });
  }

  return <>{children}</>;
};

export function createEditorialModal(
  Component: (props: any) => React.ReactNode
): IEditorialDecisionModal {
  const Wrapped = ((props: IDecisionModalProps) => (
    <EditorialDecisionModalWrapper>
      {Component(props)}
    </EditorialDecisionModalWrapper>
  )) as IEditorialDecisionModal;
  Wrapped.__isEditorialModal = true;
  return Wrapped;
}

interface EditorialDecisionModalWrapperProps {
  children: React.ReactNode;
}
